import { toAmount } from './feeAmount.utils';
import {
  FeeToleranceCategory,
  SECTION_TOLERANCE_CATEGORY,
  TOLERANCE_BUCKET_DESCRIPTION,
  TOLERANCE_CHIP_CONFIG,
  TOLERANCE_SECTIONS,
} from './feeTolerance.constants';

const getSectionToleranceCategory = cdSection => SECTION_TOLERANCE_CATEGORY[cdSection] ?? null;

const getToleranceChipConfig = category =>
  category ? (TOLERANCE_CHIP_CONFIG[category] ?? null) : null;

export const getFeeToleranceBuckets = (main = {}) => {
  const buckets = new Map();

  TOLERANCE_SECTIONS.forEach(cdSection => {
    const category = getSectionToleranceCategory(cdSection);

    if (!category) {
      return;
    }

    const section = main[cdSection];

    if (!section) {
      return;
    }

    const existing = buckets.get(category) ?? {
      category,
      sections: [],
      amount: 0,
    };

    existing.sections.push(cdSection);
    existing.amount += toAmount(section.totalAmount);
    buckets.set(category, existing);
  });

  return [
    FeeToleranceCategory.ZERO,
    FeeToleranceCategory.TEN_PERCENT,
    FeeToleranceCategory.UNLIMITED,
  ]
    .filter(category => buckets.has(category))
    .map(category => {
      const bucket = buckets.get(category);

      return {
        ...bucket,
        chip: getToleranceChipConfig(category),
        description: TOLERANCE_BUCKET_DESCRIPTION[category],
      };
    });
};
